import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {Possessed} from "../Possessed";
import {PossessedReelsView} from "../reels/PossessedReelsView";
import {SimpleReelModel, SimpleReelModelState} from "../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap"
import {PossessedGameMode} from "../server/PossessedGameMode";
import {PossessedWildSymbol} from "../reels/PossessedWildSymbol";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class PossessedNormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const tl:TimelineLite = new TimelineLite({onComplete:() => flowStateController.finish()});
        const delay = PossessedReelsView.stepDuration;
        tl.add(() => {Possessed.soundPlayer.playLoopingSound("reelsSpinning")})

        Possessed.reelView.getAllVisibleSymbols().filter(s => s.name != "S").forEach(sym => {
            sym.resetState();
        })
        Possessed.winCounter.resetState();

        // Reset wild girl on top of center cross
        tl.add(Possessed.reelView.reelCross.fadeOutWildGirl(0.2));
        // Remove fullScreen M1
        tl.add(Possessed.reelView.hideFullScreenM1(0.3), "<");

        const centerCrossSym = Possessed.reelView.getSymbolAt(2, 3);
        let syncMiddleReels = centerCrossSym.isFullCrossSymbol;
        if(centerCrossSym.name == "W") {
            syncMiddleReels = (<PossessedWildSymbol>centerCrossSym).isExpandedWild;
        }

        // https://github.com/nolimitcity/possessed/issues/218
        const reverseSpin = !Possessed.model.isActionSpinsBet && Possessed.model.triggeredFreespins() ||
            !Possessed.model.isActionSpinsBet && (Possessed.model.isFreespins() && Possessed.model.data.nextMode == PossessedGameMode.FREESPIN || Possessed.model.data.nextMode == PossessedGameMode.FREESPIN_SUPER);

        const hotZones = Possessed.model.data.nextHotZoneSize;
        if(!Possessed.model.isActionSpinsBet && hotZones > 0 && (Possessed.model.data.nextMode != PossessedGameMode.NORMAL)) {
            tl.add(Possessed.reelView.reelCross.spinMysteryReels(Possessed.model.data.nextHotZoneSize, Possessed.model.data.xCrucifixReel, reverseSpin), 0);
        }

        //tl.add(this.spinMysteryReels(delay, reverseSpin), 0);
        tl.add(Possessed.reelView.reelModels[0].start(reverseSpin), 0);

        tl.add(Possessed.reelView.reelModels[1].start(reverseSpin), delay);
        tl.add(() => {
            Possessed.reelView.reelCross.setFireSpinAnimationAtReel(1, reverseSpin);
        }, "<");

        tl.add(Possessed.reelView.reelModels[2].start(reverseSpin), syncMiddleReels ? delay : delay * 2);
        tl.add(() => {
            Possessed.reelView.reelCross.setFireSpinAnimationAtReel(2, reverseSpin);
        }, "<");

        tl.add(Possessed.reelView.reelModels[3].start(reverseSpin), syncMiddleReels ? delay : delay * 3);
        tl.add(() => {
            Possessed.reelView.reelCross.setFireSpinAnimationAtReel(3, reverseSpin);
        }, "<");

        tl.add(Possessed.reelView.reelModels[4].start(reverseSpin), delay * 4);

        // https://github.com/nolimitcity/possessed/issues/218
        tl.add(() => {
            if(Possessed.model.isActionSpinsBet) {
                Possessed.model.isActionSpinsBet = false;
            }
        })
    }

    private spinMysteryReels(reelStartOffset:number, reverse:boolean = false):gsap.core.Timeline {
        const tl = gsap.timeline();

        const hotZones = Possessed.model.data.nextHotZoneSize;
        if(hotZones != 0 && (Possessed.model.data.nextMode != PossessedGameMode.NORMAL)) {
            Possessed.reelView.reelCross.getAllMysteryReels().slice(0, hotZones).forEach(mysteryReel => {
                tl.add(() => {
                    mysteryReel.updateReelSet(Possessed.model.data.xCrucifixReel);
                    mysteryReel.start(reverse);
                }, reelStartOffset * mysteryReel.reelID)
            });
        }
        return tl;
    }
}